import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import SecondaryButton from '../../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import { httpDisableUser } from '../../../Hooks/user/user.put.hooks';
// Disables a user
const DisableUserButton = ({ setSuccessState, setIsOpen, id }) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (id) => httpDisableUser(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
      setSuccessState('User has been disabled');
      setIsOpen(true);
    },
    onError: (error) => {
      console.error('Error updating user:', error);
      setSuccessState('Failed to disable user');
      setIsOpen(true);
    },
  });

  const handleDisable = (e) => {
    e.preventDefault();
    setSuccessState('Disabling user...');
    mutation.mutate(id);
  };

  return (
    <>
      <Suspense fallback={<p>Loading button...</p>}>
        <SecondaryButton functionName={handleDisable} span="Disable User" />
      </Suspense>
    </>
  );
};

DisableUserButton.propTypes = {
  setSuccessState: PropTypes.func,
  setIsOpen: PropTypes.func,
  id: PropTypes.string,
};

export default DisableUserButton;
